// onboarding-components-registry.ts
import {LazyExoticComponent, lazy} from 'react';
import OnboardingWelcome from './components/onboarding-dynamic-content';

// type d'un composant React FC
type OnboardingComp = LazyExoticComponent<React.FC<any>>;

// On associe des strings (stockés en BDD) à des composants lazy()
export const onboardingComponentMap: Record<string, OnboardingComp> = {
  OnboardingDynamicContent: lazy(() => import('@app/web-player/onboarding/components/onboarding-dynamic-content')),
  OnboardingPushNotifications: lazy(() => import('@app/web-player/onboarding/components/onboarding-push-notifications')),
  OnboardingSiriAuthorization: lazy(() => import('@app/web-player/onboarding/components/onboarding-siri-authorization')),
  OnboardingFocusArtist: lazy(() => import('@app/web-player/onboarding/components/onboarding-focus-artist')),
  OnboardingSelectGenres: lazy(() => import('@app/web-player/onboarding/components/onboarding-select-genres')),
};
